import React, { Component } from "react";
import gif from "../../../assets/images/contact-gif.gif";
import { Link } from "react-router-dom";
import "../../../styles/pages/home/HomeContact.css";

export default class HomeContact extends Component {
  render() {
    return (
      <div className="HomeContact gutters">
        {/* The Text */}
        <div className="text-container">
          <div className="g-title desktop on-scroll-anim">WHAT'S UP, DOG?</div>
          <div className="g-sub-text on-scroll-anim">
            We know finding the right person to make your website can be ruff.
            Get ahold of us at any time, we’ll paws what we’re doing and get the
            ball rolling.{" "}
          </div>
          <Link className="g-button on-scroll-anim" to="contact">
            Get In Touch
          </Link>
        </div>

        {/* The Gif */}
        <div className="image-container on-scroll-anim">
          <img src={gif} alt="Cute doggo" />
        </div>
        <div className="g-title mobile on-scroll-anim">WHAT'S UP, DOG?</div>
      </div>
    );
  }
}
